import { Wizard, Image } from '@lana-ui/common';
import { Error } from '@lana-ui/login';

import LoadingSpinner from '@helpers/LoadingSpinner';
import ErrorGral from '../../Statics/Imgs/loginImg/error-gral.png';

import VentaBonificada from '../../Pages/VentaBonificada';
import Confirmacion from '../../Pages/Confirmacion';
import DatosPersonales from '../../Pages/DatosPersonales';
import IngresarDomicilio from '../../Pages/Domicilios/IngresarDomicilio';
import RealizarPago from '../../Pages/Pago/RealizarPago';
import PagoPendiente from '../../Pages/PagoPendiente';
import YaSosSuscriptor from '../../Pages/YaSosSuscriptor';

import { steps } from '../../Config/CheckoutSteps';
import DomiciliosGuardados from '../../Pages/Domicilios/DomiciliosGuardados';
import GetParamURL from '../../Helpers/GetParamURL';
import { telefono, whatsApp } from '../../Config/DatosDeContacto';

export const StepsCheckout = ({ state, send }) => {
    //TODO probar si funciona todo bien.
    const states = [
        { name: 'validarPlanDeVenta' },
        { name: 'loadingObtenerCampania' },
        { name: 'loadingObtenerDescripcionPlan' },
        { name: 'loadingObtenerMontoACobrar' },
        { name: 'loadingObtenerDatosFiliatorios' },
        { name: 'saveStepInformation_1'},
        { name: 'datosPersonales', component: DatosPersonales },
        { name: 'validarDatosPersonales' },
        { name: 'validarSuscripciones' },
        { name: 'realizarPago', component: RealizarPago },
        { name: 'obtenerDomiciliosGuardados' },
        { name: 'domiciliosGuardados', component: DomiciliosGuardados },
        { name: 'ingresarDomicilio', component: IngresarDomicilio },
        { name: 'submitDomicilio' },
        { name: 'ventaBonificada', component: VentaBonificada },
        { name: 'gracias', component: Confirmacion },
        { name: 'pagoPendiente', component: PagoPendiente },
        { name: 'yaSosSuscriptor', component: YaSosSuscriptor },
        { name: 'redirectPaywall' },
        { name: 'error', component: YaSosSuscriptor }
    ];

    const findState = states.find((el) => state.matches(el.name));

    const Element = findState.component ? findState.component : LoadingSpinner;

    const { URLCallback } = GetParamURL();

    return findState?.name === 'error' ? (
        <Error
            title={state.history?.value === 'ventaBonificada' ? "No podemos procesar tu solicitud" : "Ha ocurrido un error"}
            text={state.history?.value === 'ventaBonificada' ? `Para suscribirte, llamanos al ${telefono} o escribinos por WhatsApp al ${whatsApp}` : "Por favor, intentalo nuevamente"}
            firstButtonLabel="Volver"
            imageUrl={<Image src={ErrorGral} width="220px" />}
            firstButtonOnClick={() => (window.location = `${URLCallback ? URLCallback : process.env.REACT_APP_LNREDIRECT}`)}
        />
    ) : (
        <>
            <Element state={state} send={send} isLoading={state.context.isLoading} />
        </>
    );
};
